/**
 * Assigns teams to an initiative via the BON record.
 * Creates a new BON if one doesn't exist, otherwise updates the existing one.
 *
 * @param {Store} store - Ember Data store
 * @param {OrganisationService} orgService - organisation service
 * @param {Initiative} initiative - the initiative record
 * @param {string[]} team_ids - array of team IDs to assign
 */
export async function assignTeamsToInitiative(
  store,
  orgService,
  initiative,
  team_ids,
) {
  let bon = await initiative.bon.catch(() => null);
  if (!bon)
    bon = createNewBonWithProvidedTeams(
      store,
      orgService,
      initiative,
      team_ids,
    );
  else bon = updateExistingBonWithProvidedTeams(orgService, bon, team_ids);

  await bon.save();
  const teams = team_ids.map((id) => store.peekRecord('team', id));
  initiative.teams = teams.filter((item) => !!item);
  initiative.reload();
}

function createNewBonWithProvidedTeams(
  store,
  orgService,
  initiative,
  team_ids,
) {
  const bon = store.createRecord('bon');
  bon.initiative = initiative;
  bon.investments = { value: 0, calculations: [] };
  bon.returns = { value: 0, calculations: [] };
  bon.value = 0;

  team_ids.map((team_id) => {
    bon.investments.calculations.push({
      type: 'person-weeks-role',
      confidence_label: 'Medium',
      confidence_value: orgService.bon_investment_confidences['medium'],
      team_id,
      weeks: 0,
      people: 0,
      value: 0,
      price_person_week: orgService.ppw,
    });
  });

  return bon;
}

function updateExistingBonWithProvidedTeams(orgService, bon, team_ids) {
  const team_map = team_ids.reduce((acc, team_id) => {
    acc[team_id] = { checked: false };
    return acc;
  }, {});

  if (!bon?.investments) bon.investments = { value: 0, calculations: [] };

  for (let i = 0; i < bon.investments?.calculations?.length; i++) {
    const calculation = bon.investments.calculations[i];
    if (calculation.type !== 'person-weeks-role') continue;
    if (!calculation.team_id) continue;
    if (team_map[calculation.team_id]) {
      team_map[calculation.team_id].checked = true;
    } else {
      calculation.team_id = undefined;
    }
  }

  Object.entries(team_map).forEach(([team_id, { checked }]) => {
    if (!checked) {
      bon.investments.calculations.push({
        type: 'person-weeks-role',
        confidence_label: 'Medium',
        confidence_value: orgService.bon_investment_confidences['medium'],
        team_id,
        weeks: 0,
        people: 0,
        value: 0,
        price_person_week: orgService.ppw,
      });
    }
  });

  return bon;
}
